import { Injectable } from "@angular/core";
import { TreasuryBankAccountsService } from "lib-klab-sdks";
import { map, Observable } from "rxjs";
import { BankAccountsPort } from "../../../app/ports/treasury/bank-accounts.port";
import {
  BankAccount,
  BankAccountRequest,
  BankAccountPage,
  BankAccountPageRequest,
} from "../../../domain/models/treasury/bank-account.model";
import {
  mapTreasuryBankAccount,
  mapTreasuryBankAccountRequest,
} from "../../mappers/treasury/bank-account.mapper";

@Injectable({ providedIn: "root" })
export class BankAccountsPortAdapter implements BankAccountsPort {
  constructor(private readonly api: TreasuryBankAccountsService) {}

  listPage(request: BankAccountPageRequest): Observable<BankAccountPage> {
    return this.api.listPage(request).pipe(map(({ data }) => ({
      ...data,
      content: data.content.map(mapTreasuryBankAccount),
    })));
  }

  listBySupplier(id: number): Observable<readonly BankAccount[]> {
    return this.api.listBySupplier(id).pipe(map(({ data }) => data.map(mapTreasuryBankAccount)));
  }

  listByCompany(id: number): Observable<readonly BankAccount[]> {
    return this.api.listByCompany(id).pipe(map(({ data }) => data.map(mapTreasuryBankAccount)));
  }

  listByOwner(id: number): Observable<readonly BankAccount[]> {
    return this.api.listByOwner(id).pipe(map(({ data }) => data.map(mapTreasuryBankAccount)));
  }

  get(id: number): Observable<BankAccount> {
    return this.api.get(id).pipe(map(({ data }) => mapTreasuryBankAccount(data)));
  }

  create(request: BankAccountRequest): Observable<BankAccount> {
    return this.api.create(mapTreasuryBankAccountRequest(request)).pipe(map(({ data }) => mapTreasuryBankAccount(data)));
  }

  update(id: number, request: BankAccountRequest): Observable<BankAccount> {
    return this.api.update(id, mapTreasuryBankAccountRequest(request)).pipe(map(({ data }) => mapTreasuryBankAccount(data)));
  }

  delete(id: number): Observable<void> {
    return this.api.delete(id).pipe(map(() => undefined));
  }
}
